import { MAX_FEEDBACK_MESSAGE_LENGTH } from '@okletsplay/core';
import { object, string } from 'yup';

export const createFeedbackValidationSchema = object().shape({
  message: string().required().max(MAX_FEEDBACK_MESSAGE_LENGTH).label('Feedback Message'),
});
